import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=4ea6f9ea&scoped=true"
import script from "./Permissions.vue?vue&type=script&lang=ts"
export * from "./Permissions.vue?vue&type=script&lang=ts"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=4ea6f9ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea6f9ea",
  null
  
)

export default component.exports